/* jscs:disable disallowFunctionDeclarations*/
(function(){
  'use strict';

  angular
    .module('AcaApp')
    .directive('ngErrorPage', NgErrorPage);

  NgErrorPage.$inject = [];

  function NgErrorPage(){
    return{
      restrict: 'E',
      scope: {
        configuration: '=',
        back: '&'
      },
      templateUrl: 'app/views/common/directives/errorPage/errorPage.html',
      link: function(scope){
        scope.goBack = function(){
          scope.back();
        };
      }
    };
  };
})();